import React, { ReactNode, FC, useContext, useMemo } from 'react';
import { SCP } from 'ia-react-core/~/interfaces/SCP';

import { WithSpacingProps } from 'ia-react-core/~/hocs/grid/withSpacing';
import COLOR_SCHEMES from '../../../constants/COLOR_SCHEMES';
import ColorSchemeContext from '../../colorScheme/ColorSchemeContext';
import { StyledBox } from './Box.styles';

export interface BoxProps extends SCP<'div'>, WithSpacingProps {
  /** The block's content */
  children: ReactNode;
  /** Style the box white. */
  white?: boolean;
}

/**
 * @since 0.18.0
 */
const Box: FC<BoxProps> = ({ children, ...props }) => {
  const { scheme } = useContext(ColorSchemeContext);
  const newScheme = useMemo(() => {
    if (scheme === COLOR_SCHEMES.LIGHT) {
      return COLOR_SCHEMES.SHADE;
    }

    if (scheme === COLOR_SCHEMES.SHADE) {
      return COLOR_SCHEMES.LIGHT;
    }

    return scheme;
  }, [scheme]);
  const newSchemeContext = useMemo(() => ({ scheme: newScheme }), [newScheme]);

  return (
    <ColorSchemeContext.Provider value={newSchemeContext}>
      <StyledBox scheme={scheme} {...props}>
        {children}
      </StyledBox>
    </ColorSchemeContext.Provider>
  );
};

export default Box;
